export default "__VITE_ASSET__C1m6WjxJ__"